export const KULLANIM_HEDEFLERI = ["triaj", "parca", "fitup", "bom"];
export const KALDIRMA_NEDENLERI = ["secim_degisti", "set_sifirlama", "is_geri", "sokum"];
/** "Used in" listesindeki "(selection removed: …)" metni (İngilizce; web cevir'ler). */
export const KALDIRMA_NEDENI_METNI = {
    secim_degisti: "selection changed",
    set_sifirlama: "set reset",
    is_geri: "job sent back",
    sokum: "no longer missing in Disassembly",
};
export const HAREKET_TURLERI = ["acilis", "gelis", "sayim", "duzeltme", "bitti"];
/** "Quantity history" tür kolonu (İngilizce; web cevir'ler). */
export const HAREKET_TURU_METNI = {
    acilis: "opening stock",
    gelis: "arrival",
    sayim: "count",
    duzeltme: "correction",
    bitti: "finished",
};
export const PAKET_KAYNAKLARI = ["kutukler", "acilis", "urun_geldi", "demo"];
/** Miktarlar 3 ondalığa yuvarlanır (60.266 + 60 = 120.266; kayan nokta artığı kalmaz). */
export const yuvarla3 = (n) => Math.round((n + Number.EPSILON) * 1000) / 1000;
/** PKG no. gösterimi: 23 → "PKG-0023". */
export const pkgNo = (no) => `PKG-${String(no).padStart(4, "0")}`;
/** Kalanı 0 (ya da altı) olan paket bitmiştir; ayrı bayrak yok (D-046). */
export const paketBitti = (p) => p.miktar <= 0;
/** Yalnız rakamsa "002" / "7" → "R002" / "R007"; öteki değerler olduğu gibi ("R162", klamp işlerinin "KAMP"). */
export const riserRnBicimi = (rn) => (/^\d+$/.test(rn) ? "R" + rn.padStart(3, "0") : rn);
/** Birim m ise "Heat <iz>", öteki birimlerde iz öneksiz; boşsa null. */
export function izMetni(birim, iz) {
    const d = (iz ?? "").trim();
    if (!d)
        return null;
    return birim === "m" ? `Heat ${d}` : d;
}
const doldur = (metin, ...arg) => metin.replace(/\{(\d+)\}/g, (t, n) => (arg[Number(n)] === undefined ? t : String(arg[Number(n)])));
const gunMetni = (iso) => {
    const [y, a, g] = iso.slice(0, 10).split("-");
    return `${g}/${a}/${y}`;
};
const kisalt = (s, enCok) => (enCok && s.length > enCok ? s.slice(0, Math.max(1, enCok - 1)).trimEnd() + "…" : s);
/**
 * Seçenek metni (0.4/3): "PN — tanım · <iz> · PO <no> · <kalan> <birim> · opening stock | arrived <tarih> · PKG-####"; boş alan yazılmaz.
 * "opening stock": kaynak "acilis"; "arrived {0}": gelisTarihi doluysa; miktar yuvarla3.
 */
export function paketSecenekMetni(p, s) {
    const cevir = s?.cevir ?? doldur;
    const tanim = (p.tanim ?? "").trim();
    const parcalar = [tanim ? `${p.pn} — ${kisalt(tanim, s?.tanimEnCok)}` : p.pn];
    const iz = izMetni(p.birim, p.iz);
    if (iz)
        parcalar.push(iz);
    if (p.poNo?.trim())
        parcalar.push(`PO ${p.poNo.trim()}`);
    parcalar.push(`${yuvarla3(p.miktar)} ${p.birim}`);
    if (p.kaynak === "acilis")
        parcalar.push(cevir("opening stock"));
    else if (p.gelisTarihi)
        parcalar.push(cevir("arrived {0}", (s?.tarih ?? gunMetni)(p.gelisTarihi)));
    parcalar.push(pkgNo(p.no));
    return parcalar.join(" · ");
}
/** Biten paketin kısa etiket eki (fit-up / weld map etiketinde web bu eki ayırıp "(package finished)" olarak çevirir). */
export const PAKET_BITTI_EKI = " (package finished)";
/** Fit-up malzeme etiketi ve triyaj log değeri: "56026001122 · PO 2026-0588 · PKG-0023" (+ " (package finished)" bitmişse). */
export function paketKisaEtiketi(p) {
    const parcalar = [p.pn];
    if (p.poNo?.trim())
        parcalar.push(`PO ${p.poNo.trim()}`);
    parcalar.push(pkgNo(p.no));
    return parcalar.join(" · ") + (paketBitti(p) ? PAKET_BITTI_EKI : "");
}
/** stok_kullanim.etiket biçimleri (İngilizce kopya; web cevir kalıbıyla çevirir). İş kimliği ilk 8 karakteriyle yazılır. */
export const kullanimEtiketi = {
    /** "Triage · Fastener #76 Retainer (Ring Retainer)" */
    triaj: (komponentAd, no, kalem) => `Triage · ${komponentAd} #${no} ${kalem}`,
    /** "Part list · Riser Bolt Washer" */
    parca: (ad) => `Part list · ${ad}`,
    /** "Fit-up W2 · job 5bcf8c07" | "Fit-up · job 5bcf8c07" (kalem düzeyi eski form) */
    fitup: (tamirId, kaynakNo) => kaynakNo === null || kaynakNo === undefined ? `Fit-up · job ${tamirId.slice(0, 8)}` : `Fit-up W${kaynakNo} · job ${tamirId.slice(0, 8)}`,
    /** "Product arrived · Box connector · job 5bcf8c07" */
    bom: (tanim, tamirId) => `Product arrived · ${tanim} · job ${tamirId.slice(0, 8)}`,
};
/* ---------- Registers: kütük kullanım özeti ---------- */
export const KUTUK_KULLANIM_TURLERI = ["fitup", "paso", "ekSarf", "triyaj", "is", "eskiAkis", "sokum", "triyajDegisim", "bom", "rapor"];
export const BOS_KULLANIM = { toplam: 0, parcalar: [] };
/** [tekil, çoğul]; çoğulda {0}. Web her parçayı çevirip " · " ile birleştirir. */
export const KUTUK_KULLANIM_METNI = {
    fitup: ["used in 1 fit-up", "used in {0} fit-ups"],
    paso: ["used in 1 pass record", "used in {0} pass records"],
    ekSarf: ["used in 1 additional material record", "used in {0} additional material records"],
    triyaj: ["used in 1 triage item", "used in {0} triage items"],
    is: ["used in 1 job", "used in {0} jobs"],
    eskiAkis: ["used in 1 old-flow item", "used in {0} old-flow items"],
    sokum: ["used in 1 disassembly record", "used in {0} disassembly records"],
    triyajDegisim: ["used in 1 triage replacement", "used in {0} triage replacements"],
    bom: ["used in 1 job material row", "used in {0} job material rows"],
    /** D-059: rapora bağlı test ekipmanı (Project documents) */
    rapor: ["used in 1 report", "used in {0} reports"],
};
//# sourceMappingURL=stok-paket.js.map